import { all, call, takeEvery } from 'redux-saga/effects';

import services from '../services';
import EntryActionTypes from '../../../constants/EntryActionTypes';

export default function* organizationsWatchers() {
  yield all([
    takeEvery(EntryActionTypes.ORGANIZATION_MEMBER_INVITE, function* ({ payload: { organizationId, data } }) {
      yield call(services.inviteOrganizationMember, organizationId, data);
    }),
    takeEvery(EntryActionTypes.ORGANIZATION_FROM_CLERK_SYNC, function* ({ payload: { organizationId } }) {
      yield call(services.syncOrganizationFromClerk, organizationId);
    }),
    takeEvery(EntryActionTypes.ORGANIZATION_MEMBER_REMOVE, function* ({ payload: { organizationId, userId } }) {
      yield call(services.removeOrganizationMember, organizationId, userId);
    }),
    takeEvery(EntryActionTypes.ORGANIZATION_MEMBERSHIP_DELETE_HANDLE, function* ({ payload: { organizationId, userId } }) {
      yield call(services.handleOrganizationMembershipDelete, organizationId, userId);
    }),
  ]);
}
